import { Box, Chip, TextField, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import { Toast } from "../../../../components/Toast";

const ToEmailSection = ({ formData, setFormData }) => {
  const colors = useColors();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && formData.to.trim() !== "") {
      const email = formData.to.trim();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (emailRegex.test(email)) {
        setFormData((prevState) => ({
          ...prevState,
          emails: [...prevState.emails, email],
          to: "", // Clear the input
        }));
      } else {
        Toast.error("Invalid email address");
      }

      event.preventDefault();
    }
  };
  const onBlur = (event) => {
    if (formData.to.trim() !== "") {
      const email = formData.to.trim();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emailRegex.test(email)) {
        setFormData((prevState) => ({
          ...prevState,
          emails: [...prevState.emails, email],
          to: "", // Clear the input
        }));
      } else {
        Toast.error("Invalid email address");
      }
    }
  };

  const handleDelete = (emailToDelete) => () => {
    setFormData((prevState) => ({
      ...prevState,
      emails: prevState.emails.filter((email) => email !== emailToDelete),
    }));
  };

  return (
    <Box
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: 2,
        padding: 1,
        display: "flex",
        flexDirection: "row",
        gap: 2,
        alignItems: "baseline",
        backgroundColor: colors.common_white,
      }}
    >
      <Typography variant="subtitle2" gutterBottom>
        To:
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignItems: "center", // Align items vertically in the center
          flex: 1, // Allow the Box to grow and shrink
        }}
      >
        {formData.emails.map((email, index) => {
          if (email !== "") {
            return (
              <Chip
                key={index}
                label={email}
                onDelete={handleDelete(email)}
                sx={{ margin: "2px", backgroundColor: colors.primary_4percent }}
              />
            );
          }
        })}
        <TextField
          variant="standard"
          name="to"
          value={formData.to}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onBlur={onBlur}
          sx={{
            flex: 1, // Allow the TextField to grow and shrink
            minWidth: "150px", // Set a minimum width for the TextField
            "& .MuiInput-underline:before": {
              borderBottom: "none",
            },
            "& .MuiInput-underline:after": {
              borderBottom: "none",
            },
            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
              borderBottom: "none",
            },
            "& .MuiInputBase-input": {
              color: colors.text_secondary,
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default ToEmailSection;
